import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getEaccountingArticleUnitGroups = (token: string, backend: string) => {
    return fetch(`${getApiUrl(backend)}eaccounting_article_unit_groups`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getEaccountingArticleUnitGroups